import { FeeAdjustmentFields, FeeCollections } from '../../../types';

// Local UI state for a fee adjustment (amount kept as a string for the input)
export interface FeeAdjustmentState {
  amount: string;
  comment: string;
  customerNote: string;
}

export const EMPTY_FEE_ADJUSTMENT: FeeAdjustmentState = {
  amount: '',
  comment: '',
  customerNote: '',
};

export function parseAdjustmentAmount(amount: string): number {
  const n = parseFloat(amount);
  return isNaN(n) ? 0 : n;
}

// A reason (comment) is required whenever a non-zero amount is entered (backend returns 422 otherwise)
export function isAdjustmentIncomplete(state: FeeAdjustmentState): boolean {
  return parseAdjustmentAmount(state.amount) !== 0 && !state.comment.trim();
}

// Build the request-body subset for the fee adjustment; empty object when no amount is set
export function buildFeeAdjustmentPayload(state: FeeAdjustmentState): FeeAdjustmentFields {
  const amount = parseAdjustmentAmount(state.amount);
  if (amount === 0) return {};
  return {
    fee_adjustment_amount: amount,
    fee_adjustment_comment: state.comment.trim(),
    ...(state.customerNote.trim()
      ? { fee_adjustment_customer_note: state.customerNote.trim() }
      : {}),
  };
}

// Pull the currently applied discount code out of a preview's fee_collections (for pre-fill/carry-forward)
export function extractAppliedDiscountCode(fc?: FeeCollections): string {
  const line = fc?.discount?.[0];
  return line?.calculation_details?.discount?.code || '';
}
